import type { Plugin } from 'chart.js';

/**
 * https://www.chartjs.org/docs/latest/configuration/canvas-background.html
 */
export const customCanvasBackgroundColorPlugin: Plugin = {
    id: 'customCanvasBackgroundColor',
    beforeDraw: (chart, _, options) => {
        const { ctx } = chart;
        ctx.save();
        ctx.globalCompositeOperation = 'destination-over';
        ctx.fillStyle = options.color || '#99ffff';
        ctx.fillRect(0, 0, chart.width, chart.height);
        ctx.restore();
    },
};

/**
 * https://www.chartjs.org/docs/latest/configuration/canvas-background.html
 */
export const customCanvasBackgroundColorOptions = {
    customCanvasBackgroundColor: {
        color: '#fff',
    },
} as const;

/**
 * Break a label into fixed-length chunks so long text (e.g. survey question
 * text) doesn't overflow a chart's bars/axes. Chart.js renders a `string[]`
 * label as multiple lines. Chunks by character count rather than word
 * boundaries since Japanese text doesn't reliably contain spaces.
 */
export function wrapChartLabel(text: string, maxLineLength = 20): string[] {
    const lines: string[] = [];
    for (let i = 0; i < text.length; i += maxLineLength) {
        lines.push(text.slice(i, i + maxLineLength));
    }
    return lines;
}
